<template>
    <ValidationProvider
        :name="name"
        :rules="rules"
        v-slot="{ errors }"
        :class="classWrapper"
        class="custom-wrapper"
        tag="div"
    >
        <div v-if="showTooltip" class="custom-info">
            <img class="ico" src="@/assets/images/info-icon.svg" alt="info" @click="toggleShowTooltip" />
            <div
                v-if="isShowTooltip"
                class="custom-tooltip"
                v-click-outside="closeTooltip"
            >
                <div class="custom-tooltip__title">{{ tooltipTitle }}</div>
                <div class="custom-tooltip__desc">
                    {{ tooltipDesc }}
                </div>
                <i
                    class="fa fa-times-circle custom-tooltip__close"
                    aria-hidden="true"
                    @click="closeTooltip"
                ></i>
            </div>
        </div>
        <div class="custom-form-control">
            <textarea
                v-bind="$attrs"
                :value="value"
                @input="onInput"
                :id="name"
                placeholder=""
            />
            <label :for="name">{{ label }}</label>
        </div>
        <span :class="[showTooltip && 'show-tooltip']" class="custom-error">{{
            errors[0]
        }}</span>
    </ValidationProvider>
</template>

<script>
export default {
    name: 'TextareaField',
    data() {
        return {
            isShowTooltip: false,
        };
    },
    props: {
        label: String,
        value: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        rules: [String, Array, Object],
        classWrapper: String,
        showTooltip: Boolean,
        tooltipTitle: String,
        tooltipDesc: String,
    },
    created() {
        setTimeout(() => {
            this.$nextTick(() => {
                const textarea = this.$el.querySelector('textarea');
                textarea.style.height = 'auto';
                textarea.style.height = `${textarea.scrollHeight}px`;
            });
        }, 300);
    },
    methods: {
        onInput(event) {
            this.$emit('input', event.target.value);
        },
        toggleShowTooltip() {
            this.isShowTooltip = !this.isShowTooltip;
        },
        closeTooltip() {
            this.isShowTooltip = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-wrapper {
    display: flex;
    flex-wrap: wrap;
}
.custom-form-control {
    background-color: #e1e7e9;
    padding: 24px 16px 8px 16px;
    border-radius: 12px;
    position: relative;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    flex-grow: 1;

    &.focus {
        background-color: #e1e7e9;
    }

    label {
        color: #969fa2;
        font-size: 14px;
        position: absolute;
        margin-bottom: 0;
        top: 10px !important;
        left: 0;
        right: 0;
        bottom: auto;
        z-index: 2;
        padding: 16px;
        transition: all 0.1s ease-in-out;
        cursor: text;
    }

    textarea {
        border: none;
        background: none;
        font-size: 18px;
        color: rgba(51, 48, 60, 0.68);
        padding: 0;
        width: 100%;

        &::placeholder {
            visibility: hidden;
        }

        &:focus + label,
        &:not(:placeholder-shown) + label {
            font-size: 13px;
            opacity: 0.7;
            padding-block: 0;
            top: 8px;
            color: #1b659e;
        }
    }
}
.custom-error {
    color: var(--danger);
    font-size: 12px;
    width: 100%;
    &.show-tooltip {
        margin-left: 30px;
    }
}
.custom-info {
    position: relative;
    .ico {
        color: #7bbdef;
        font-size: 20px;
        cursor: pointer;
        margin-right: 8px;
        margin-top: 20px;
    }
}
.custom-tooltip {
    position: absolute;
    border-radius: 30px;
    background: #edf5f7;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    min-width: 400px;
    padding: 20px;
    z-index: 10;
    transform: translate(30px, -60px);

    &__title {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px; /* 150% */
        color: #41b8dc;
        margin-bottom: 8px;
    }

    &__desc {
        font-size: 16px;
        line-height: 24px; /* 150% */
        color: #7c7c7a;
    }

    &__close {
        position: absolute;
        right: 16px;
        top: 8px;
        color: #2178ab !important;
        cursor: pointer;
    }
}
</style>
